import React from "react";
import styles from "./hiddenReportsMessage.module.scss";

export interface IHiddenReportsMessageProps {
    nrOfHiddenReports: number;
}

const HiddenReportsMessage: React.FC<IHiddenReportsMessageProps> = ({ nrOfHiddenReports }) => {

    if (nrOfHiddenReports === 0) {
        return null;
    }

    let sentence: string;
    if (nrOfHiddenReports === 1) { sentence = "výkaz je skrytý"; }
    else if (nrOfHiddenReports > 1 && nrOfHiddenReports <= 4) {
        sentence = "výkazy jsou skryté";
    }
    else { sentence = "výkazů je skryto"; }

    return (
        <small className={styles.hiddenReportsContainer}>
            {nrOfHiddenReports} {sentence}, protože je aktivováno filtrování.
        </small>
    )
};

export default HiddenReportsMessage;
